module.exports = __webpack_public_path__ + "static/media/sculpture3.6f3a67ec.jpg";